<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="inertia-link"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create_multiple'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-3">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.stages', 1)" for="stage_id" />
                            <FormSelect
                                required
                                id="stage_id"
                                v-model="form.stage_id"
                                :options="options.stages"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.stage_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-5">
                        <FormLabel :value="$t('messages.grade_level')" for="grade_level_ids" />
                        <div class="mt-1">
                            <SlideOverCheckboxInput v-model="form.grade_level_ids" :options="filteredGradeLevels" />
                        </div>
                    </div>

                    <SelectWithPreferences
                        class="sm:col-span-8"
                        :options="filteredSubjects"
                        name="subject_id"
                        :required="true"
                        :label="$tc('messages.subject', 1)"
                        property-name="text"
                        :preferences="defaults.preferences.subject_ids"
                        property-value="value"
                        v-model="form.subject_id"
                    />

                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.trimester')" for="trimester" />
                            <FormSelect
                                required
                                id="trimester"
                                v-model="form.trimester"
                                :options="options.trimesters"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.trimester" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div>
                <ActivityBatchCreateTable
                    v-model="form.activities"
                    :options="options"
                    :defaults="defaults"
                    :errors="form.errors"
                />
            </div>

            <div class="flex justify-end mt-5 space-x-2">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import ActivityBatchCreateTable from '@/components/ActivityBatchCreateTable.vue';
import SelectWithPreferences from '@/components/SelectWithPreferences.vue';
import AppButton from '@/components/AppButton.vue';
import SlideOverCheckboxInput from '@/components/Forms/SlideOverCheckboxInput.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormLabel,
        FormError,
        FormSelect,
        ActivityBatchCreateTable,
        SelectWithPreferences,
        AppButton,
        SlideOverCheckboxInput,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'activity', 'defaults'],
    computed: {
        filteredGradeLevels: function () {
            return this.options.grade_levels.filter((s) => s.stage_id == this.form.stage_id);
        },
        filteredSubjects: function () {
            return this.options.subjects.filter((s) => s.stage_id == this.form.stage_id);
        },
    },
    watch: {
        'form.stage_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.form.grade_level_ids = [];
                this.form.subject_id = null;
            }
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                stage_id: this.defaults.stage_id,
                subject_id: '',
                grade_level_ids: this.defaults.preferences.grade_level_id,
                trimester: this.defaults.trimester,
                activities: [],
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
